import React, {memo} from 'react'

type Option = {
  label: string
  value: string | number
}

type TestRadioProps = {
  article?: string
  value: string | number
  onChange: (val: string | number) => void
  options: Option[]
}

const TestRadio: React.FC<TestRadioProps> = memo(({ value, onChange, options, article }) => {
  return (
    <div className='testOptionGroup'>
      {options.map((opt) => {
        const selected = value === opt.value
        return (
        <div
          key={opt.value}
          className={`testOptionItem ${value === opt.value ? 'selected' : ''}`}
          onClick={() => onChange(opt.value)}
        >
          <div className='testOptionIcon radio'>
            {selected && <div className='radioChecked' />}
          </div>
          <div>{opt.label}</div>
        </div>
      )})}
    </div>
  )
})

export default TestRadio
